// TODO use it in app
export const TIME_FORMATS = {
  awsDate: 'YYYY-MM-DD',
  date: 'DD.MM.YYYY',
  time: 'HH:mm',
  dateTime: 'DD.MM.YYYY HH:mm',
  dateTimeFull: 'DD.MM.YYYY HH:mm:ss',
  dayShort: 'dd',
  dayLong: 'dddd',
  countDown: 'HH:mm:ss',
  monthAndYear: 'MMMM YYYY',
  seconds: 'ss',
  dateTitle: 'DD MMM. | dddd',
  dateTimeTitle: 'DD MMM. | HH:mm',
  dateTimeHTMLLocal: 'YYYY-MM-DDTHH:mm',
} as const;
